import {
  GET_REPORT_SCHEDULERS_REQUEST,
  GET_REPORT_SCHEDULERS_SUCCESS,
  GET_REPORT_SCHEDULERS_FAILURE,
  SCHEDULE_DASHBOARD_REQUEST,
  SCHEDULE_DASHBOARD_SUCCESS,
  SCHEDULE_DASHBOARD_FAILURE,
  UPDATE_SCHEDULER_REQUEST,
  UPDATE_SCHEDULER_SUCCESS,
  UPDATE_SCHEDULER_FAILURE,
  DELETE_REPORTS_REQUEST,
  DELETE_REPORTS_SUCCESS,
  DELETE_REPORTS_FAILURE
} from '../../actions/Organization/reportSchedulerActions';

const initialState = {
  loading: false,
  schedulers: [],
  error: null
};

export default function reportSchedulerReducer(state = initialState, action) {
  switch (action.type) {
    case GET_REPORT_SCHEDULERS_REQUEST:
    case SCHEDULE_DASHBOARD_REQUEST:
    case UPDATE_SCHEDULER_REQUEST:
    case DELETE_REPORTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };

    case GET_REPORT_SCHEDULERS_SUCCESS:
      return {
        ...state,
        loading: false,
        schedulers: action.payload,
        error: null
      };

    case SCHEDULE_DASHBOARD_SUCCESS:
    case UPDATE_SCHEDULER_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case DELETE_REPORTS_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null
      };

    case GET_REPORT_SCHEDULERS_FAILURE:
    case SCHEDULE_DASHBOARD_FAILURE:
    case UPDATE_SCHEDULER_FAILURE:
    case DELETE_REPORTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      };

    default:
      return state;
  }
} 